import React, { useEffect, useRef, useCallback } from 'react';
import styled from 'styled-components';
import Container from 'ls-common-client/dist/components/Container';
import classNames from 'classnames';

const StyledContainer = styled(Container)`
  border-radius: 11px;
  box-shadow: 0 2px 30px 0 rgba(0, 0, 0, 0.02);
  border: solid 1px #ececec;
  background: #ffffff;
  padding: 25px 35px 20px;
  margin-bottom: 100px;
  margin-right: 20px;
  height: 704px;
  overflow-y: auto;
  flex: 1;
  @media (max-width: 1024px) {
    padding: 20px;
    margin-right: 0;
    margin-bottom: 20px;
    height: auto;
    max-height: 600px;
  }
`;

const ScrollContainer = ({
  className,
  children,
  onScrollToBottom,
  id,
  ...props
}) => {
  const ref = useRef();
  const innerRef = useRef();

  const handleScroll = useCallback(async () => {
    const { scrollTop } = ref.current || {};
    const { height } = ref.current.getBoundingClientRect() || {};
    const { clientHeight } = innerRef.current || {};
    if (clientHeight > scrollTop && scrollTop > clientHeight - height) {
      await onScrollToBottom();
    }
  }, [ref, innerRef, onScrollToBottom]);

  useEffect(() => {
    if (onScrollToBottom && id) {
      document.getElementById(id).addEventListener('scroll', handleScroll, {
        passive: true,
      });
      return () =>
        document.getElementById(id).removeEventListener('scroll', handleScroll);
    }
    return () => {};
  }, [onScrollToBottom, id]);

  return (
    <StyledContainer
      {...props}
      className={classNames('UserManagement__Container', {
        [className]: className,
      })}
      id={id}
      ref={ref}
    >
      <div ref={innerRef}>{children}</div>
    </StyledContainer>
  );
};

export default ScrollContainer;
